import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import AppLayout from "@/components/AppLayout";
import { Calculator, Users, FileText, Banknote, ArrowRight } from "lucide-react";

const TOOLS = [
  { to: "/app/sueldos", icon: Banknote, t: "Recibo de Sueldos", d: "Calculá los sueldos según normativa aplicable." },
  { to: "/app/legajos", icon: Users, t: "Legajos", d: "Gestioná empleados, empresa y datos para el recibo." },
  { to: "/app/recibos", icon: FileText, t: "Recibos", d: "Emití y descargá recibos Ley 20.744 en PDF." },
  { to: "/app/calculadora", icon: Calculator, t: "Calculadora SAC", d: "Liquidá el aguinaldo del semestre con topes y detracción." },
];

export default function ToolsIndexPage() {
  const { user } = useAuth();
  const [stats, setStats] = useState({ legajos: 0, calculos: 0, recibos: 0 });

  useEffect(() => {
    Promise.all([api.get("/legajos"), api.get("/calculations"), api.get("/receipts")])
      .then(([l, c, r]) => setStats({ legajos: l.data.length, calculos: c.data.length, recibos: r.data.length }))
      .catch(() => {});
  }, []);

  return (
    <AppLayout title={`Hola, ${user?.nombre || ""}`} subtitle="Índice de herramientas Holistor">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-border border border-border mb-8">
        {[
          { l: "Legajos", v: stats.legajos }, { l: "Cálculos guardados", v: stats.calculos }, { l: "Recibos emitidos", v: stats.recibos },
        ].map((s) => (
          <div key={s.l} className="bg-white p-6" data-testid={`stat-${s.l}`}>
            <p className="label-tiny">{s.l}</p>
            <p className="font-head text-4xl font-bold text-slate-900 mt-2 tabular">{s.v}</p>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-border border border-border">
        {TOOLS.map((t) => (
          <Link key={t.to} to={t.to} data-testid={`tool-${t.to.split("/").pop()}`}
            className="bg-white p-7 group hover:bg-slate-50 transition-colors">
            <div className="flex items-start justify-between">
              <t.icon size={26} strokeWidth={1.4} className="brand-accent-text" />
              <ArrowRight size={18} className="text-slate-300 group-hover:translate-x-1 transition-transform" />
            </div>
            <h3 className="font-head text-lg font-bold text-slate-900 mt-4">{t.t}</h3>
            <p className="text-sm text-muted-foreground mt-1.5 leading-relaxed">{t.d}</p>
          </Link>
        ))}
      </div>
    </AppLayout>
  );
}
